// extracted by mini-css-extract-plugin
module.exports = {"csr_pc_swiper":"Swiper_csr_pc_swiper__BIRaZ"};